export default __webpack_public_path__ + "static/media/Card Payment API.efb7a622.jpg";